class DashboardCardActivityCtrl {
  constructor(ActivityService, FeedStore, UserService, $scope: ng.IScope, $element) {
    const ctrl: ng.IController = this;
    ctrl.$onInit = () => {
      UserService.projects().then((res) => {
        ctrl.projects = res.data.data;
        ctrl.projectsCount = res.data.count;
      });

      UserService.invitations().then((res) => {
        ctrl.invitations = res.data.data;
        ctrl.invitationsCount = res.data.count;
      });

      ActivityService.feed().then((res) => {
        ctrl.activities = ActivityService.combine(res.data);
      });

      ActivityService.communityActivities().then((res) => {
        ctrl.communityActivities = ActivityService.combine(res.data);
      });

      ctrl.activeTab = 'All';
      // This card's own tab list, not the first .nav-tabs on the page.
      ctrl.navTabs = $element[0].getElementsByClassName('nav-tabs');
      // Sets tab roles on <ul> <li> <a>, and ties each tab to its panel.
      setTimeout(() => {
        ctrl.navTabs[0].setAttribute('role', 'tablist');
        ctrl.navTabs[0].setAttribute('aria-label', 'My Activity');
        const tabElements = ctrl.navTabs[0].children;
        const panes = $element[0].querySelectorAll('.tab-pane');
        for (let i = 0; i < tabElements.length; i++) {
          const tab = tabElements[i].firstElementChild;
          tabElements[i].setAttribute('role', 'presentation');
          tab.setAttribute('role', 'tab');
          tab.id = `dashboardActivityTab${i}`;
          tab.setAttribute('aria-selected', ctrl.activeTab === tabElements[i].type);
          if (panes[i]) {
            panes[i].id = `dashboardActivityPanel${i}`;
            panes[i].setAttribute('role', 'tabpanel');
            panes[i].setAttribute('aria-labelledby', tab.id);
            tab.setAttribute('aria-controls', panes[i].id);
          }
        }
      });
    };

    ctrl.setSelectedTab = (elem) => {
      ctrl.activeTab = elem;
      const tabElements = ctrl.navTabs[0]?.children || [];
      for (let i = 0; i < tabElements.length; i++) {
        tabElements[i].firstElementChild.setAttribute('aria-selected', ctrl.activeTab === tabElements[i].type);
      }
      if (ctrl.activeTab === 'Projects') {
        ActivityService.clearProjectActivities();
        $scope.$emit('clearProjectNotificationCounter');
      } else if (ctrl.activeTab === 'Community') {
        ActivityService.clearCommunityActivities();
        $scope.$emit('clearCommunityNotificationCounter');
      }
    };
  }
}

DashboardCardActivityCtrl.$inject = ['ActivityService', 'FeedStore', 'UserService', '$scope', '$element'];

export default DashboardCardActivityCtrl;
